import React from 'react';

import {SiteBridgeSettingsForSiteAdminProps} from '~src/settings/general-settings/components/bridge-settings/BridgeSiteSettings';
import {BridgeRemoteAgentsSectionBody} from '~src/settings/general-settings/components/sections/bridge/BridgeRemoteAgentsSectionBody';
import {BridgeRemoteAgentsSectionHeaders} from '~src/settings/general-settings/components/sections/bridge/BridgeRemoteAgentsSectionHeaders';

import {Messages} from '../../../../../codegen/Localize';
import {SettingsSection} from '../../../../components/common/SettingsSection';
import {componentRegistryEntry} from '../../SettingsComponentRegistryFunctions';

export function BridgeRemoteAgentsSection(props: SiteBridgeSettingsForSiteAdminProps) {
  return (
    <SettingsSection title={Messages.siteRemoteAgentSettingsAgentsStatus()}
                     testId={'bridge-remote-agents-section'}>
      <table className={'tb-static-grid-table tb-static-grid-table-remote-agents-width'}>
        <BridgeRemoteAgentsSectionHeaders/>
        <BridgeRemoteAgentsSectionBody {... props}/>
        </table>
    </SettingsSection>
  );
}

/* for registering the component in settings registry */
export const BridgeRemoteAgentsSectionSpecs = componentRegistryEntry({
  name: 'BridgeRemoteAgentsSection',
  component: BridgeRemoteAgentsSection
});
